/**
 * demoPersona.ts — The Demo User's Story
 *
 * "Alex" is a realistic GLP-1 user mid-journey. Week 8 on Mounjaro 5mg.
 * Started at 104kg, now 90kg. Consistent logger, hitting protein targets,
 * healthy deficit. Functional age improving. This is the success story
 * we want demo visitors to aspire to.
 *
 * All demographic data lives here, referenced by demoData.ts.
 * To change the demo narrative, edit this file only.
 *
 * Place at: src/demo/demoPersona.ts
 */

export const demoPersona = {
  // Identity
  firstName: 'Alex',
  userId: 'demo-user',

  // Demographics
  age: 35,
  sex: 'male' as const,
  heightCm: 178,

  // Weight journey
  currentWeightKg: 90.0,
  startWeightKg: 104.0,
  goalWeightKg: 82.0,

  // Body composition
  bodyFatPercent: 23.5,
  goalBodyFat: 18.0,
  muscleMassKg: 62.0,

  // Preferences
  units: 'metric' as const,

  // GLP-1 journey
  medication: 'Mounjaro',
  dose: '5mg',
  weekOnGlp1: 8,
  doseDay: 'mon' as const,

  // Logging behaviour (for narrative — not used in data generation)
  loggingStreakDays: 23,
  avgProteinAdherence: 0.92, // 92% of days hitting target

  // Functional Age story
  chronologicalAge: 35,
  functionalAge: 31.2, // 3.8 years younger — the headline hook
} as const;
